import { usePlatformStore } from '@/stores/platform';

export function usePlatformConnection() {
  const platformStore = usePlatformStore();

  function isNotConnected(platform) {
    return (
      !platformStore.pending.platformConnections && !platformStore.isPlatformConnected(platform)
    );
  }

  function connect(platform) {
    platformStore.connect(platform);
  }

  return {
    connect,
    isNotConnected,
  };
}
